import React from 'react';
import { 
  FaCrosshairs, // Remplace FaTarget
  FaCheckCircle,
  FaHome,
  FaPlaneDeparture,
  FaFolderOpen,
  FaPenAlt,
  FaUniversity,
  FaGlobeAmericas,
  FaBriefcase,
  FaGlobe,
  FaComments,
  FaBullseye,
  FaUserTie,
  FaWhatsapp,
  FaGraduationCap,
  FaMapMarkerAlt,
  FaFileAlt,
  FaNetworkWired,
  FaHandshake,
  FaStar,
  FaShieldAlt,
  FaRocket,
  FaLightbulb,
  FaHandsHelping
} from 'react-icons/fa';
import { FiMessageCircle, FiGlobe } from 'react-icons/fi';
import './EtudiantEtrangerHorsFrance.css';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const EtudiantEtrangerHorsFrance = () => {
  const services = [
    { 
      icon: <FaCrosshairs />, // Utilise FaCrosshairs au lieu de FaTarget
      text: 'Orientation académique personnalisée' 
    },
    { 
      icon: <FaCheckCircle />, 
      text: 'Obtention d\'une admission dans une université ou école française (délai moyen : 10 à 14 jours)' 
    },
    { 
      icon: <FaHome />, 
      text: 'Recherche de logement en France' 
    },
    { 
      icon: <FaPlaneDeparture />, 
      text: 'Accompagnement complet sur la procédure Visa Étudiant' 
    },
    { 
      icon: <FaFolderOpen />, 
      text: 'Création d\'un dossier Campus France solide' 
    },
    { 
      icon: <FaPenAlt />, 
      text: 'Élaboration d\'une lettre de motivation et d\'un projet d\'étude cohérent' 
    },
    { 
      icon: <FaUniversity />, 
      text: 'Accès à notre réseau de +60 écoles françaises partenaires' 
    },
    { 
      icon: <FaGlobeAmericas />, 
      text: 'Préparation à l\'intégration en France (conseils, documents, checklists)' 
    },
    { 
      icon: <FaBriefcase />, 
      text: 'Job étudiant, Stage et Alternance en France' 
    }
  ];

  const contacts = [
    { 
      name: 'Emmanuel', 
      phone: '+33 6 95 74 40 27',
      icon: <FaUserTie />
    },
    { 
      name: 'Marie Claude', 
      phone: '+33 7 49 91 11 12',
      icon: <FaUserTie />
    },
    { 
      name: 'Sandrine', 
      phone: '+33 6 52 34 15 47',
      icon: <FaUserTie />
    }
  ];

  const createWhatsAppLink = (phone, name) => {
    const message = `Bonjour ${name}, je suis intéressé(e) par vos services pour étudier en France.`;
    return `https://wa.me/${phone.replace(/\s/g, '')}?text=${encodeURIComponent(message)}`;
  };

  return (
    <section className="student-abroad-sectionbigcontain">
         <Header />
    <section className="student-abroad-section">
        
      <div className="student-abroad-canvas">
        <div className="student-abroad-decoration">
          {/* Avions voyageurs avec icônes */}
          <div className="student-airplane airplane-1">
            <FaPlaneDeparture />
          </div>
          <div className="student-airplane airplane-2">
            <FaPlaneDeparture />
          </div>
          <div className="student-airplane airplane-3">
            <FaPlaneDeparture />
          </div>
          
          {/* Globe tournant */}
          <div className="student-globe">
            <FiGlobe />
          </div>
          
          {/* Orbes décoratives */}
          <div className="student-travel-orb travel-orb-1"></div>
          <div className="student-travel-orb travel-orb-2"></div>
          <div className="student-travel-orb travel-orb-3"></div>
          
          {/* Éléments décoratifs supplémentaires */}
          <div className="student-decor-element decor-1">
            <FaGraduationCap />
          </div>
          <div className="student-decor-element decor-2">
            <FaMapMarkerAlt />
          </div>
          <div className="student-decor-element decor-3">
            <FaFileAlt />
          </div>
        </div>
      </div>

      <div className="student-abroad-wrapper">
        {/* Header avec icônes */}
        <div className="student-abroad-header">
          <h1 className="student-abroad-title">
            <FaGlobe className="title-icon" />
            Étudiant étranger Hors France
          </h1>
          <p className="student-abroad-subtitle">
            Nous accompagnons les étudiants dans <span className="student-abroad-highlight">toutes les étapes de leur projet d'étude en France</span>
          </p>
          
          {/* Stats avec icônes */}
          <div className="student-stats-container">
            <div className="student-stat-item">
              <div className="student-stat-icon">
                <FaUniversity />
              </div>
              <div className="student-stat-content">
                <h3>60+</h3>
                <p>Écoles partenaires</p>
              </div>
            </div>
            <div className="student-stat-item">
              <div className="student-stat-icon">
                <FaHandshake />
              </div>
              <div className="student-stat-content">
                <h3>100%</h3>
                <p>Accompagnement personnalisé</p>
              </div>
            </div>
            <div className="student-stat-item">
              <div className="student-stat-icon">
                <FaRocket />
              </div>
              <div className="student-stat-content">
                <h3>10-14</h3>
                <p>Jours pour admission</p>
              </div>
            </div>
          </div>
        </div>

        {/* Services avec icônes */}
        <div className="student-services-container">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="student-service-item" 
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="student-service-icon-wrapper">
                <div className="student-service-icon">
                  {service.icon}
                </div>
              </div>
              <div className="student-service-content">
                <p className="student-service-text">
                  {service.text.includes('délai moyen') ? (
                    <>
                      {service.text.split('(délai moyen : ')[0]}
                      <span className="student-deadline">
                        <FaStar style={{ marginRight: '5px' }} />
                        (délai moyen : {service.text.split('(délai moyen : ')[1]}
                      </span>
                    </>
                  ) : service.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Objectif avec icônes */}
        <div className="student-objective-box">
          <div className="objective-icon-wrapper">
            <FaBullseye className="objective-main-icon" />
          </div>
          <h3 className="student-objective-title">
            <FaCrosshairs style={{ marginRight: '10px' }} /> {/* Utilise FaCrosshairs ici aussi */}
            Notre Objectif
          </h3>
          <p className="student-objective-text">
            <FaLightbulb style={{ marginRight: '10px' }} />
            Donner aux étudiants africains un accès simplifié, sécurisé et professionnel à l'enseignement supérieur français.
          </p>
          <div className="objective-features">
            <div className="objective-feature">
              <FaShieldAlt className="feature-icon" />
              <span>Sécurisé</span>
            </div>
            <div className="objective-feature">
              <FaNetworkWired className="feature-icon" />
              <span>Professionnel</span>
            </div>
            <div className="objective-feature">
              <FaHandsHelping className="feature-icon" />
              <span>Accompagné</span>
            </div>
          </div>
        </div>

        {/* Contact avec icônes */}
        <div className="student-contact-section">
          <div className="contact-header-icon">
            <FaComments />
          </div>
          <h2 className="student-contact-title">
            Contactez un de nos agents
          </h2>
          <div className="student-contact-grid">
            {contacts.map((contact, index) => (
              <div key={index} className="student-contact-card">
                <div className="contact-card-icon">
                  {contact.icon}
                </div>
                <h3 className="student-contact-name">{contact.name}</h3>
                <p className="student-contact-role">
                  <FaGraduationCap style={{ marginRight: '8px' }} />
                  Conseiller en études en France
                </p>
                <a
                  href={createWhatsAppLink(contact.phone, contact.name)}
                  className="student-whatsapp-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="student-whatsapp-icon">
                    <FaWhatsapp />
                  </span>
                  <span className="whatsapp-text">
                    WhatsApp: {contact.phone}
                  </span>
                </a>
              </div>
            ))}
          </div>
          <p className="student-contact-note">
            <FiMessageCircle style={{ marginRight: '8px' }} />
            Cliquez sur un bouton pour directement laisser un message sur WhatsApp
          </p>
        </div>
      </div>
     
    </section>
      <Footer />
    </section>
  );
};

export default EtudiantEtrangerHorsFrance;